import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { creditCardValidator, expiryDateValidator, cpfValidator } from '../../../utils/validators';
import { cardExpiry, cardNumber, cpfMask } from '../../../utils/masks';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';
import * as moment_ from 'moment';

const moment = moment_;

@Component({
  selector: 'ng-tickets-add-card',
  styleUrls: ['./add-card.component.scss', '../../tickets/styles/ticket.scss'],
  templateUrl: './add-card.component.html'
})
export class AddCardComponent implements OnInit {

  @Input() productSale: ProductSale;

  @Output() nextStep = new EventEmitter();

  // Form Groups
  form: FormGroup;

  // Form Controls
  cardNumber: FormControl;
  holderName: FormControl;
  expiryDate: FormControl;
  cvv: FormControl;
  cpf: FormControl;

  expiryMask = cardExpiry;
  cardMask = cardNumber;
  cpfMask = cpfMask;

  constructor(
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.createFormControls();
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      holder_name: this.holderName,
      card_number: this.cardNumber,
      expiryDate: this.expiryDate,
      cvv: this.cvv,
      cpf: this.cpf
    });
  }

  createFormControls() {
    const { card } = this.productSale;
    const expiryDate = (card && card.exp_month && card.exp_year) ? moment({M: card.exp_month - 1, y: card.exp_year}).format('MM/YYYY') : '';

    this.cardNumber = new FormControl(card && card.card_number || '', [Validators.compose([Validators.required, creditCardValidator])]);
    this.holderName = new FormControl(card && card.holder_name || '', [Validators.required, Validators.minLength(3), Validators.pattern('[a-zA-Z ]*')]);
    this.expiryDate = new FormControl(expiryDate, [Validators.required, expiryDateValidator]);
    this.cvv = new FormControl(card && card.cvv || '', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]);
    this.cpf = new FormControl(card && card.holder_document || '', [Validators.required, cpfValidator]);
  }

  submitForm() {
    this.markFormGroupTouched(this.form);

    if (this.form.valid) {
      const { expiryDate, card_number, cpf, ...form } = this.form.value;

      this.productSale.card = {
        ...form,
        card_number: card_number.replace(/\D/g, ''),
        exp_month: parseInt(expiryDate.split('/')[0], 10),
        exp_year: parseInt(expiryDate.split('/')[1], 10),
        holder_document: cpf.replace(/\D/g, '')
      };

      if (this.productSale.billing_address) {
        this.nextStep.emit('card-confirm');
      } else {
        this.nextStep.emit('address-list');
      }
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  backEvent() {
    const { cardsLength, billing_address, card } = this.productSale;

    if (cardsLength) {
      if (billing_address && card) {
        this.nextStep.emit('card-confirm');
      } else {
        this.nextStep.emit('card-list');
      }
    } else {
      this.nextStep.emit('card-selection');
    }
  }

  nextButtonText() {
    const { billing_address, card } = this.productSale;

    if (billing_address) {
      return card.editing ? 'Salvar alterações' : 'Validar dados';
    } else {
      return 'Endereço de cobrança';
    }
  }
}
